import { render, staticRenderFns } from "./ReservaLegal.vue?vue&type=template&id=162ca222&lang=pug"
import script from "./ReservaLegal.vue?vue&type=script&lang=js"
export * from "./ReservaLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports